import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

export const useFilteredFromSmartlinksButtons = (
  buttons: FlowChartButton[],
  smartLinkButtonIdsMap: Map<string, boolean>,
): FlowChartButton[] => {
  return buttons.filter((button) => !smartLinkButtonIdsMap.has(button.id))
}
